import { createContext } from 'react';

// True inside a dashboard window that shows a whole admin page (Office dashboard, Oct 9 2026):
// AdminLayout then draws only the page, not the side menu and header around it.
const EmbedContext = createContext(false);
export default EmbedContext;
